import React from 'react';
import { Box } from '@mui/material';
import Link from '@mui/material/Link';
import RenovationVoiceImage from '@components/common/RenovationVoiceImage';
import RenovationVoice from '@/types/components/RenovationVoice/RenovationVoice';

interface RenovationVoiceDetailProps {
  voice: RenovationVoice;
}

export default function RenovationVoiceDetail({ voice }: RenovationVoiceDetailProps): React.JSX.Element {
  return (
    <Box className="group">
      <RenovationVoiceImage
        className="md:h-64 md:aspect-video md:object-cover group-hover:opacity-60"
        src={voice.image[0]}
        alt={voice.headline}
        href={voice['@context']}
      />
      <Link
        href={voice['@context']}
        variant="body1"
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          marginTop: 1,
          textDecoration: 'none',
        }}
        className="font-bold text-sm text-rf-blue"
      >
        {voice.headline}
      </Link>
    </Box>
  );
}
